(function() {
    'use strict';

    angular
        .module('gatewayApp')
        .config(stateConfig);

    stateConfig.$inject = ['$stateProvider'];

    function stateConfig($stateProvider) {
        $stateProvider
        .state('ifsc-upload-view', {
            parent: 'entity',
            params:{screen: 'HomeBranchIFSCUpload'},
            url: '/home-branch-ifsc-upload',
            data: {
                authorities: ['ROLE_USER'],
                pageTitle: 'global.title'
            },
            ncyBreadcrumb: {
                label: '{{ "global.menu.homeBranchUpload.main" | translate }}',
                parent: 'home'
            },
            views: {
                'content@': {
                    templateUrl: 'app/entities/home-branch-ifsc-upload/home-branch-ifsc-upload.html',
                    controller: 'HomeBranchIfscUploadController',
                    controllerAs: 'vm'
                }
            },
            resolve: {
                translatePartialLoader: ['$translate', '$translatePartialLoader', function ($translate, $translatePartialLoader) {
                   
                    $translatePartialLoader.addPart('homeBranchIfscUpload');
                    $translatePartialLoader.addPart('error');
                    $translatePartialLoader.addPart('global');
                    return $translate.refresh();
                }]
               
            }
        })
      
         };
    })();
